<template>
  <div id="admin">
    <menu-admin />
    <section class="int-form" style="margin-top: 30px;">
      <div class="container">
        <div class="text-right d-print-none action-badges">
          <a
            id="changePrefix"
            class="badge badge-info"
            href="#"
            style="color: white !important;"
            data-toggle="modal"
            data-target="#prefixModal"
          >
            <i class="fa fa-plane" aria-hidden="true"></i> Alterar prefixo
          </a>
          <a
            class="badge badge-info"
            href="javascript:window.print();"
            style="color: white !important;"
          >
            <i class="fa fa-print" aria-hidden="true"></i> Imprimir
          </a>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="prefixModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="prefixModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="prefixModalLabel">Informe o prefixo da aeronave</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="prefix">Prefixo:</label>
                  <input id="prefix" v-mask="'AA-AAA'" class="form-control" />
                  <span class="errorForm"></span>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  id="hideModal"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >Close</button>
                <button type="button" @click="getOrders()" class="btn btn-primary">Pesquisar</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="prefix === null" class="row" style="margin-top: 30px;">Selecione um prefixo</div>

        <div v-else class="row">
          <div class="col-12 title-report">
            <h5>Relatório de Pedidos x Prefixo</h5>
            <h1>Prefixo: {{prefix}}</h1>
            <br />

            <table
              class="table table-bordered table-sm table-hover"
              style="background: white; font-size: 0.8em"
            >
              <tr v-show="!computed_orders.length">
                <td class="text-center" colspan="4">Nenhum pedido encontrado para {{prefix}}</td>
              </tr>
              <thead v-show="computed_orders.length">
                <tr>
                  <th class="text-center" width="100" scope="col">Pedido</th>
                  <th class="text-center" width="100">Status</th>
                  <th class="text-center">Data</th>
                  <th scope="col">Cliente</th>
                  <th class="text-center" scope="col">Publicação</th>
                  <th class="text-center" width="200" scope="col">Prefixo / N Série</th>
                  <th class="text-center" scope="col">NF</th>
                </tr>
              </thead>
              <tbody v-show="computed_orders.length">
                <tr v-for="order in computed_orders" v-bind:key="order.id">
                  <td class="text-center">#{{order.id}}</td>
                  <td class="text-center">{{order.status}}</td>
                  <td class="text-center">{{order.date | formatDate}}</td>
                  <td>{{order.name}}</td>
                  <td class="text-center">{{order.publication_name}}</td>
                  <td
                    class="text-center"
                  >{{order.airplane_prefix}} / {{order.airplane_serial_number}}</td>
                  <td class="text-center">{{order.nfe}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <footer-admin />
  </div>
</template>

<script>
import menuAdmin from "../admin/common/menu-admin";
import footerAdmin from "../admin/common/footer-admin";
import mixins from "../../helpers/mixins";
import reports from "../../api/reports";

export default {
  name: "ReportOrderPrefix",
  mixins: [mixins],
  data() {
    return {
      prefix: null,
      orders: {},
    };
  },
  components: { menuAdmin, footerAdmin },
  methods: {
    getOrders() {
      if ($("#prefix").val() !== "") {
        this.prefix = $("#prefix").val();
      }

      reports
        .order_by_prefix({ prefix: this.prefix })
        .then((response) => {
          this.orders = response.data;
          $("#prefixModal").modal("hide");
        })
        .catch((errors) => {
          this.formErrors(errors);
        });
    },
  },
  computed: {
    computed_orders: function () {
      let comp_orders = [];

      for (let key in this.orders) {
        for (let key_pub in this.orders[key]["publications"]) {
          let name = null;
          if (this.orders[key]["profile"]["person_or_company"]) {
            name = this.orders[key]["profile"]["company_name"];
          } else {
            name = this.orders[key]["profile"]["name"];
          }

          comp_orders.push({
            id: this.orders[key]["id"],
            status: this.orders[key]["status"],
            date: this.orders[key]["date"],
            name: name,
            publication_name: this.orders[key]["publications"][key_pub][
              "publication"
            ]["name"],
            airplane_prefix: this.orders[key]["publications"][key_pub][
              "airplane_prefix"
            ],
            airplane_serial_number: this.orders[key]["publications"][key_pub][
              "airplane_serial_number"
            ],
            nfe: this.orders[key]["nfe"],
          });
        }
      }

      return comp_orders;
    },
  },
  mounted() {
    if (this.$route.params.prefix === "null") {
      $("#prefixModal").modal("show");
    } else {
      this.prefix = this.$route.params.prefix;
      this.getOrders();
    }
  },
};
</script>

<style scoped>
.action-badges {
  margin-top: 80px;
  padding-top: 10px;
  z-index: 1;
  position: relative;
}

.title-report {
  margin-top: -20px;
}

@media screen and (max-width: 999px) {
  .action-badges {
    margin-top: 100px;
    padding-top: 0px;
    padding-bottom: 10px;
    z-index: 1;
    position: relative;
  }

  .title-report {
    margin-top: 0;
  }
}
</style>